module.exports = __webpack_public_path__ + "img/market.8a71e10e.png";